document.addEventListener("DOMContentLoaded", () => {

    var container, video, playButton, pauseButton, muteButton

    const handlePause = () => {
        if (video.paused == false) {
            // Pause the video
            video.pause();
            playButton.classList.remove('hidden')
            pauseButton.classList.add('hidden')
        } else {
            console.log('pause error')
        }
    }

    const handlePlay = () => {
        if (video.paused == true) {
            // Play the video
            video.play();
            playButton.classList.add('hidden')
            pauseButton.classList.remove('hidden')
        } else {
            console.log('play error')
        }
    }

    const handleMute = () => {
        console.log('video:', video)
        console.log('muteButton:', muteButton)
        if (video.muted == false) {
            // Mute the video
            video.muted = true;
            muteButton.querySelector('.icon-mute').classList.remove('hidden')
            muteButton.querySelector('.icon-unmute').classList.add('hidden')
        } else {
            // Unmute the video
            video.muted = false;
            muteButton.querySelector('.icon-mute').classList.add('hidden')
            muteButton.querySelector('.icon-unmute').classList.remove('hidden')
        }
    }

    document.addEventListener('click', function (e) {

        if (!e.target.closest('.pause') && !e.target.closest('.play') && !e.target.closest('.mute-wrap')) return;
        //console.log('e.target: ', e.target)

        container = e.target.closest('.video-with-controls');
        video = container.querySelector('.hero-banner-video__video')
        playButton = container.querySelector('.play')
        pauseButton = container.querySelector('.pause')
        muteButton = container.querySelector('.mute-wrap')

        if (e.target.closest('button.pause')) handlePause();
        if (e.target.closest('button.play')) handlePlay();
        if (e.target.closest('.mute-wrap')) handleMute();

    });

    // Play/Pause on scroll
    const autoplayVids = document.querySelectorAll('video[data-autoplay="true"]');
    //console.log('video elements:', autoplayVids)

    const config = {
        rootMargin: '-75px -75px',
        threshold: 0
    }
    const callback = (entries) => {
        entries.forEach((entry) => {
            container = entry.target.closest('.video-with-controls');
            video = entry.target
            playButton = container.querySelector('.play')
            pauseButton = container.querySelector('.pause')
            muteButton = container.querySelector('.mute-wrap')
            if (!entry.isIntersecting) {
                video.pause();
                console.log('Exit video', video);
            } else {
                if (!pauseButton.classList.contains('hidden')) {
                    video.play();
                    console.log('Enter video', video);
                } else {
                    console.log('play video skipped', video);
                }

            }
        });
    }

    const observer = new IntersectionObserver(callback, config);

    if (autoplayVids.length > 0) {
        autoplayVids.forEach(element => {
            observer.observe(element);
        });
    }


});